<template>
  <div class="dashboard-bg">
    <div class="header-bar">
      <div class="header-left">
        <img src="@/assets/222.png" class="header-logo" />
        <span class="header-title">老关中驾校管理系统</span>
      </div>
      <div class="header-right">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="display: flex; align-items: center; cursor: pointer;">
            <el-avatar :size="36" class="user-avatar">
              <i class="el-icon-user-solid user-icon"></i>
            </el-avatar>
            <span class="user-name">{{ roleLabel }}</span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-container class="layout-root">
      <el-aside width="220px" class="side-bar">
        <el-menu :default-active="defaultMenu" router class="side-menu" :unique-opened="true">
          <!-- Super 账户只显示账号管理 -->
          <el-menu-item v-if="isSuper" index="/account">
            <i class="el-icon-s-custom"></i>
            <span slot="title">账号管理</span>
          </el-menu-item>
          
          <!-- 非 Super 账户显示原有菜单 -->
          <template v-if="!isSuper">
            <el-menu-item v-if="!isSubadmin" index="/region">
              <i class="el-icon-location"></i>
              <span slot="title">区域管理</span>
            </el-menu-item>
            <el-menu-item v-if="!isSubadmin" index="/coach">
              <i class="el-icon-s-custom"></i>
              <span slot="title">教练管理</span>
            </el-menu-item>
            <el-menu-item v-if="!isSubadmin" index="/car">
              <i class="el-icon-truck"></i>
              <span slot="title">项目管理</span>
            </el-menu-item>
            <el-menu-item v-if="!isSubadmin" index="/timeslot">
              <i class="el-icon-time"></i>
              <span slot="title">排班管理</span>
            </el-menu-item>
            <el-menu-item index="/order">
              <i class="el-icon-tickets"></i>
              <span slot="title">预约管理</span>
            </el-menu-item>
            <el-menu-item index="/user">
              <i class="el-icon-user"></i>
              <span slot="title">用户管理</span>
            </el-menu-item>
            <el-menu-item index="/face-recognition">
              <i class="el-icon-camera"></i>
              <span slot="title">人脸识别管理</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container class="main-container">
        <el-main class="main-content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  computed: {
    defaultMenu() {
      if (this.isSuper) {
        if (this.$route.path === '/account') return '/account'
        return '/account'
      }
      if (this.$route.path === '/region') return '/region'
      if (this.$route.path === '/' || this.$route.path === '/coach') return this.isSubadmin ? '/order' : '/coach'
      if (this.$route.path === '/car') return '/car'
      if (this.$route.path === '/timeslot') return '/timeslot'
      if (this.$route.path === '/order') return '/order'
      if (this.$route.path === '/user') return '/user'
      if (this.$route.path === '/face-recognition') return '/face-recognition'
      return '/region'
    },
    isSubadmin() {
      return this.$store.state.userRole === 'subadmin'
    },
    isSuper() {
      return this.$store.state.userRole === 'super'
    },
    roleLabel() {
      const role = this.$store.state.userRole
      if (role === 'super') return '超级管理员'
      if (role === 'subadmin') return '子管理员'
      return '管理员'
    }
  },
  methods: {
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$store.commit('logout')
        this.$router.replace('/login')
      }
    }
  },
  created() {
    if (this.$route.path === '/') {
      if (this.isSuper) {
        this.$router.replace('/account')
      } else {
        this.$router.replace(this.isSubadmin ? '/order' : '/coach')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-bg {
  min-height: 100vh;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.header-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 56px;
  background: #5ca1fc;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 36px 0 0;
  box-sizing: border-box;
  z-index: 100;
  border-bottom: none !important;
  box-shadow: none !important;
  border-radius: 18px 18px 0 0;
}

.header-left {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 20px;
}

.header-logo {
  width: 50px;
  height: 50px;
  margin-right: 12px;
}

.header-title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  color: #fff;
  margin-top: -7px;
}

.header-right {
  display: flex;
  align-items: center;
  height: 100%;
}

.user-avatar {
  background: #fff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  box-shadow: none;
}

.user-icon {
  color: #4ea6ff;
  font-size: 20px;
}

.user-name {
  color: #fff;
  font-size: 15px;
  margin-right: 6px;
  margin-left: 2px;
}

.layout-root {
  height: 100vh;
  width: 100vw;
  background: transparent;
  border-radius: 0;
  overflow: hidden;
  padding-top: 56px;
  box-sizing: border-box;
}

.side-bar {
  background: #fff;
  height: calc(100vh - 56px);
  width: 220px;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  z-index: 10;
  border-radius: 0;
}

.side-logo {
  height: 70px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 0;
}

.logo-img {
  width: 38px;
  height: 38px;
  margin-bottom: 2px;
}

.logo-title {
  color: #409EFF;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  text-align: center;
  line-height: 1;
}

.side-menu {
  background: transparent;
  border-right: none;
  padding-top: 12px;
}

.side-menu ::v-deep .el-menu-item {
  color: #22304a;
  font-size: 17px;
  border-radius: 10px;
  margin: 0 14px 14px 14px;
  height: 48px;
  line-height: 48px;
  transition: background 0.2s, color 0.2s;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.side-menu ::v-deep .el-menu-item i {
  font-size: 20px;
  margin-right: 10px;
}

.side-menu ::v-deep .el-menu-item.is-active {
  background: linear-gradient(90deg, #409EFF 0%, #66b1ff 100%);
  color: #fff !important;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
}

.side-menu ::v-deep .el-menu-item.is-active i {
  color: #fff !important;
}

.side-menu ::v-deep .el-menu-item:hover {
  background: #eaf4ff;
  color: #409EFF;
}

.main-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
  background: #f6f8fa;
  border-radius: 0;
}

.main-content {
  background: #f6f8fa;
  min-height: calc(100vh - 56px);
  padding: 0;
  overflow: auto;
  border-radius: 0;
}

::v-deep .el-main,
::v-deep .el-container,
::v-deep .main-container {
  border: none !important;
  border-top: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
}

::v-deep .el-main::before,
::v-deep .el-container::before,
::v-deep .main-container::before {
  border: none !important;
  border-top: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
  background: none !important;
  content: none !important;
  height: 0 !important;
  display: none !important;
}
</style>